import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom"
import style from './mobilePricingCard.module.scss';
import EditInput from "../../EditInput/input"
import RadioButton from "../../EditRadioButton/RadioButton"
import Skeleton from "../../skeleton/skeleton"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";
import { ErrorCodes } from "../../../helpers/consts/pricingConsts"
import { getManyVariant } from "../../../actions/APIcalls"
import moment from 'moment-jalaali'


const PricingCard = (props) => {
    const [isEdited, setIsEdited] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)

    useEffect(() => {
        if (isEdited) {
            props.isEditing('add')
        } else {
            props.isEditing('remove')
        }
    }, [isEdited]);


    ///lifeCycles**********************************
    useEffect(() => {
        let tmp = editInfo
        tmp.selectedPricingLabel.name = convertDropDownValue(editInfo.selectedPricingLabel.value)
        setEditInfo({ ...tmp })
        // Validator()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data])

    //functions********************************************************

    const backgroundColor = () => {
        if (!props.data.robot.salesStatus) {
            return 'wrapperGrey'
        } else {
            if (props.data.errorText) {
                return 'wrapperRed'
            } else {
                return props.data.inByBox ? 'wrapperGreen' : 'wrapperYellow'
            }
        }
    }

    const handleEditInfo = (tag, item) => {
        let tmp = editInfo
        if (tag == 'selectedPricingLabel') {
            tmp[tag] = item
        } else {
            tmp[tag] = toEnglishNumber(item.target.value.replaceAll(',', ''))
        }
        setEditInfo({ ...tmp })
        setIsEdited(true)
    }

    const resetAllEditInfo = () => {
        let tmp = editInfo
        tmp = {
            isRobotActive: props.data.robot.salesStatus,
            selectedPricingLabel: { value: props.data.robot.minimumProfitMarginType, name: convertDropDownValue(props.data.robot.minimumProfitMarginType) },
            minimumProfitMargin: props.data.robot.minimumProfitMargin,
            purchasePrice: props.data.robot.purchasePrice,
            salesPrice: props.data.salesPrice
        }
        setEditInfo({ ...tmp })
        setIsEdited(false)
    }

    const setAllEditInfo = () => {
        // call to change
        editFunction('editInfo')
        setIsEdited(false)
    }

    const convertDropDownValue = value => {
        let result = '';
        if (value.name) {
            result = value.name
        } else {
            switch (value) {
                case 'minPrice':
                    result = 'قیمت نهایی'
                    break;
                case 'percent':
                    result = 'درصد'
                    break;
                case 'price':
                    result = 'مبلغ'
                    break;
            }
        }
        return result
    }

    const editFunction = async (type) => {
        let data = props.data.robot
        if (type == 'activeRobot') {
            data.salesStatus = editInfo.isRobotActive
        } else {
            data.minimumProfitMarginType = editInfo.selectedPricingLabel.value
            data.minimumProfitMargin = editInfo.minimumProfitMargin
            data.purchasePrice = editInfo.purchasePrice
        }
        data.variantId = props.data._id
        // change SalesPrice
        if (Number(props.data.salesPrice) !== Number(editInfo.salesPrice)) {
            if (Number(editInfo.salesPrice) < Number(props.data.robot.minPrice) || Number(editInfo.salesPrice) > Number(props.data.robot.maxPrice)) {
                props.openToast('قیمت فروش وارد شده در بازه‌ی حداقل و حداکثر قیمت شما نمی‌باشد')
                resetAllEditInfo()
            } else {
                let res = props.SubmitEditSalesPrice({ productId: data.variantId, channelId: props.data.channel._id, price: Number(editInfo.salesPrice) })
                await callEditVariantFunction(data)
            }
        } else {
            await callEditVariantFunction(data)
        }
    }

    const callEditVariantFunction = async (data) => {
        // get Commission
        let commission = await getManyVariant([props.data.productGroup])
        data.DKCommission = commission.data.maxinCommission ? commission.data.maxinCommission : commission.data.minCommission
        // edit Variant ===> update variant
        setIsUpdating(true)
        let res = await props.SubmitEditVariant(data)
        setIsUpdating(false)
    }

    const calculateDate = (dateString) => {
        let result = 0
        let lastUpdate = moment.utc(dateString)
        let current = moment().utc()
        let diff = (current - lastUpdate) / 1000;
        diff /= (60 * 60);
        result = Math.floor(diff) + ' ساعت پیش'

        if (Math.floor(diff) == 0) {
            let duration = moment.duration(current.diff(lastUpdate));
            let minutes = duration.asMinutes();
            result = Math.floor(minutes) + ' دقیقه پیش'
        }
        if (Math.floor(diff) > 24) {
            let duration = moment.duration(current.diff(lastUpdate));
            let days = duration.asDays();
            result = Math.floor(days) + ' روز پیش'
        }
        return result
    }

    const [editInfo, setEditInfo] = useState({
        isRobotActive: props.data.robot.salesStatus,
        selectedPricingLabel: { value: props.data.robot.minimumProfitMarginType, name: '' },
        minimumProfitMargin: props.data.robot.minimumProfitMargin,
        purchasePrice: props.data.robot.purchasePrice,
        salesPrice: props.data.salesPrice ? props.data.salesPrice : '',
        lastUpdate: calculateDate(props.data.lastUpdate ? props.data.lastUpdate : '۱ دقیقه پیش'),
    })

    const calculateLines = text => {
        if (text.length < 65) {
            return text
        } else {
            return text.substr(0, 65) + '...'
        }
    }

    if (isUpdating) {
        return <Skeleton type='rectangle' width='100%' height='300px' />
    }
    else {
        return (
            <div className={style.wrapper}>
                <div className={style[backgroundColor()]}>
                    <div className={style.rowFlex}>
                        <Link style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}` }} target="_blank">
                            <div
                                className={style.name}
                                data-content={!props.data.newName.split(' | ')[1].includes('گارانتی') && !props.data.newName.split(' | ')[1].includes('تضمین') ? '(' + toPersianNumber(props.data.newName.split(' | ')[1]) + ')' : ''}
                            >
                                {calculateLines(toPersianNumber(props.data.newName))}
                            </div>
                        </Link>

                        <div className={style.DKPStyle}>
                            <p onClick={() => navigator.clipboard.writeText(props.data.DKPC)}>DKPC - {toPersianNumber(props.data.DKPC)}</p>
                            <p className={style.DKPSeprator}></p>
                            <p onClick={() => navigator.clipboard.writeText(props.data.DKP)}>DKP - {toPersianNumber(props.data.DKP)}</p>
                            {
                                props.data.supplierCode &&
                                <>
                                    <p className={style.DKPSeprator}></p>
                                    <p onClick={() => navigator.clipboard.writeText(props.data.supplierCode)}>{toPersianNumber(props.data.supplierCode)}</p>
                                </>
                            }
                        </div>

                        <div className={style.seprator}></div>

                        <div className={style.sellingPriceWrapper}>
                            <p className={style.title}>حداقل حاشیه سود</p>
                        </div>

                        <div className={style.inputsFrame}>
                            <div className={style.firstInput}>
                                <RadioButton
                                    value={editInfo.selectedPricingLabel.value == 'percent' ? true : false}
                                    tag='selectedPricingLabel'
                                    secondTag={props.data._id + 'percent'}
                                    label='درصد'
                                    onclick={(tag, item) => handleEditInfo('selectedPricingLabel', { value: 'percent', name: 'درصد' })}
                                    keys={props.data._id + 'percent'}
                                />
                                <RadioButton
                                    value={editInfo.selectedPricingLabel.value == 'price' ? true : false}
                                    tag='selectedPricingLabel'
                                    secondTag={props.data._id + 'price'}
                                    label='مبلغ'
                                    onclick={(tag, item) => handleEditInfo('selectedPricingLabel', { value: 'price', name: 'مبلغ' })}
                                    keys={props.data._id + 'price'}
                                />
                                <RadioButton
                                    value={editInfo.selectedPricingLabel.value == 'minPrice' ? true : false}
                                    tag='selectedPricingLabel'
                                    secondTag={props.data._id + 'minPrice'}
                                    label='قیمت نهایی'
                                    onclick={(tag, item) => handleEditInfo('selectedPricingLabel', { value: 'minPrice', name: 'قیمت نهایی' })}
                                    keys={props.data._id + 'minPrice'}
                                />
                            </div>

                            <div className={style.secondInput}>
                                <EditInput
                                    type="text"
                                    disabled={false}
                                    label=""
                                    placeholder=""
                                    tag="minimumProfitMargin"
                                    value={editInfo.minimumProfitMargin}
                                    error=''
                                    tooltip=''
                                    onchange={(e, tag) => handleEditInfo(e, tag)}
                                    onblur={() => console.log('')}
                                />
                            </div>
                        </div>

                        <div className={style.sellingPriceWrapper}>
                            <p className={style.title}>قیمت خرید</p>
                        </div>

                        <div className={style.inputsFrame}>
                            <div className={style.purchasePrice}>
                                <EditInput
                                    type="text"
                                    disabled={false}
                                    label=""
                                    placeholder=""
                                    tag="purchasePrice"
                                    value={editInfo.purchasePrice}
                                    error=''
                                    tooltip=''
                                    onchange={(e, tag) => handleEditInfo(e, tag)}
                                    onblur={() => console.log('')}
                                />
                            </div>
                        </div>

                        <div className={style.buttonWrapper}>
                            {!isEdited && <button className={style.proEditButton} onClick={() => props.threeDotHandler(props.data._id)}>تنظیمات پیشرفته</button>}
                            {isEdited && <div className={style.editCheckMark} onClick={() => setAllEditInfo()}>تایید</div>}
                            {isEdited && <div className={style.editCrossMark} onClick={() => resetAllEditInfo()}>انصراف</div>}
                        </div>
                    </div>

                </div>
                {props.data.errorText && props.data.robot.salesStatus &&
                    <div className={style.errorBox}>
                        <div className={style.textWrapper}>
                            <div className={style.icon}>n</div>
                            <p className={style.text}>{ErrorCodes[props.data.errorText] ? ErrorCodes[props.data.errorText] : toPersianNumber(numberWithCommas(props.data.errorText.replaceAll('.', '')))}</p>
                        </div>

                    </div>
                }

                {props.data.robot.pricingStrategy == 'lowestPrice' && props.data.robot.sizeOfPriceIncrease != 0 && props.data.robot.salesStatus && !props.data.errorText &&
                    <div className={style.lowestPriceBox}>
                        <div className={style.textWrapper}>
                            <div className={style.icon}>f</div>
                            <p className={style.text}>تنوع، طبق استراتژی شما، به کمترین قیمت کاهش یافت</p>
                        </div>

                    </div>
                }
                {props.data.robot.pricingStrategy == 'lowestPrice' && props.data.robot.sizeOfPriceIncrease == 0 && props.data.robot.salesStatus && !props.data.errorText &&
                    <div className={style.lowestPriceBox}>
                        <div className={style.textWrapper}>
                            <div className={style.icon}>f</div>
                            <p className={style.text}>مطابق استراتژی انتخابی، قیمت تنوع یکسان با برنده باکس قرار گرفت</p>
                        </div>

                    </div>
                }
            </div>
        )
    }
}
export default PricingCard